import { GuidePriority } from "../guide";
import type { GuideContext, GuideStep, HubFacts } from "../guide";

/**
 * Captain Bram on the season pass, "War Campaign" (MP-22): the first time the pass is open and a season runs, one line
 * pointing at the Store button (the Pass is a Store page; owner 2026-10-21 took its hub button away). Once per save, target required: no button, no line.
 */

export const PassTargets = { button: ".hub .fpill[data-pill=gems] .storebtn" } as const;

/** Hub feature tips wait for the first session (scripts/features.ts HubTipsFromCleared). */
const TipsFromCleared = 2;
const lobby = (c: GuideContext): HubFacts | null => (c.screen === "hub" && c.hub !== null && c.hub.sheet === null && c.hub.highestCleared >= TipsFromCleared ? c.hub : null);

export const passHubSteps: readonly GuideStep[] = [
  { id: "hub.pass", kind: "tip", block: "none", needsTarget: true, screen: "hub", pose: "cheering", priority: GuidePriority.NewThing, topic: "pass",
    target: { dom: PassTargets.button },
    text: "The **War Campaign** has begun! Every battle and Daily Order climbs its track in the Store toward free rewards.",
    when: (c) => lobby(c) !== null },
];
